module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Παιδικό βιβλίο με φωτογραφίες για τη γλώσσα του σώματος των σκύλων ")]), _vm._v(" "), _c('h5', [_c('a', {
    staticStyle: {
      "font-style": "italic"
    },
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Σύμβαλε στη διατήρηση της ασφάλειας των παιδιών")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26f13440","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c001.vue
// module id = 60
// module chunks = 0